import React, { useEffect, useState } from 'react';
import { Table, Input, Select, Button, Space, message, Popconfirm, Typography } from 'antd';
import { CRotationSkipProvider, CRotationSkip } from '../../domain/usdt-providers/cRotationSkipProvider';
import { GlobalSettingProvider } from '../../domain/usdt-providers/globalSettingProvider';
import { CSuccessRateDrawer } from '../components/CSuccessRateDrawer';

// 歸集 C 地址跳過清單:from=歸集錢包(商戶/用戶,量大→用清單非矩陣),to=C 地址(下拉)。
// 成功率移到「成功率」按鈕 → Drawer(帶時間範圍/筆數)。
export default function CollectCRotationSkipList({ title }: { title?: string }) {
  const [rows, setRows] = useState<CRotationSkip[]>([]);
  const [cAddrs, setCAddrs] = useState<string[]>([]);
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [remark, setRemark] = useState('');
  const [loading, setLoading] = useState(false);
  const [rateOpen, setRateOpen] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const [list, gr] = await Promise.all([
        CRotationSkipProvider.list('collect'),
        GlobalSettingProvider.get(),
      ]);
      setRows(list);
      const raw: string = (gr.data as any)?.C_ROTATION_RECEIVERS || '';
      setCAddrs(raw.split(',').map((s) => s.trim()).filter(Boolean));
    } catch (e: any) {
      message.error(e?.message ?? '載入失敗');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
  }, []);

  const add = async () => {
    if (!from.trim().startsWith('T') || !to.trim().startsWith('T')) {
      message.error('from / to 需為 T 開頭地址');
      return;
    }
    try {
      await CRotationSkipProvider.add({
        scope: 'collect',
        fromAddress: from.trim(),
        toAddress: to.trim(),
        remark: remark.trim() || undefined,
      });
      setFrom('');
      setTo('');
      setRemark('');
      load();
    } catch (e: any) {
      message.error(e?.response?.data?.message ?? e?.message ?? '新增失敗(可能已存在)');
    }
  };

  const remove = async (id: string) => {
    try {
      await CRotationSkipProvider.remove(id);
      load();
    } catch (e: any) {
      message.error(e?.message ?? '刪除失敗');
    }
  };

  return (
    <div style={{ padding: 16 }}>
      <Space style={{ width: '100%', justifyContent: 'space-between' }}>
        <Typography.Title level={4} style={{ margin: 0 }}>
          {title ?? '歸集 C 地址跳過'}
        </Typography.Title>
        <Button onClick={() => setRateOpen(true)}>成功率</Button>
      </Space>
      <Typography.Paragraph type="secondary" style={{ marginTop: 8 }}>
        歸集錢包(from,商戶/用戶皆可)選 C 供能時,跳過指定 C 地址(to)。全部被跳 → 退回 A/B。
        成功率請點右上「成功率」查看。
      </Typography.Paragraph>
      <Space style={{ marginBottom: 12 }} wrap>
        <Input
          placeholder="歸集錢包 from(貼上 T... 地址)"
          value={from}
          onChange={(e) => setFrom(e.target.value)}
          style={{ width: 320 }}
        />
        <Select
          showSearch
          allowClear
          value={to || undefined}
          onChange={(v) => setTo(v ?? '')}
          placeholder="C 地址 to(下拉選)"
          style={{ width: 320 }}
          optionFilterProp="label"
          options={cAddrs.map((c) => ({ label: c, value: c }))}
        />
        <Input
          placeholder="備註(選填)"
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          style={{ width: 180 }}
        />
        <Button type="primary" onClick={add}>
          新增
        </Button>
      </Space>
      <Table
        rowKey="id"
        loading={loading}
        pagination={false}
        dataSource={rows}
        columns={[
          { title: 'from(歸集錢包)', dataIndex: 'fromAddress' },
          { title: 'to(C 地址)', dataIndex: 'toAddress' },
          { title: '備註', dataIndex: 'remark' },
          { title: '建立時間', dataIndex: 'createdAt' },
          {
            title: '操作',
            render: (_: any, r: CRotationSkip) => (
              <Popconfirm title="刪除這筆跳過?" onConfirm={() => remove(r.id)}>
                <a>刪除</a>
              </Popconfirm>
            ),
          },
        ]}
      />
      <CSuccessRateDrawer
        scope="collect"
        title="歸集 C 供能成功率"
        visible={rateOpen}
        onClose={() => setRateOpen(false)}
      />
    </div>
  );
}
